import React, { useEffect, useMemo, useState } from "react";
import moment from "moment";
import { connect } from "react-redux";
import {
  Grid,
  Button,
  Select,
  Divider,
  TextField,
  InputLabel,
  Typography,
  FormControl,
  FormHelperText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Chip,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Tooltip,
} from "@material-ui/core";
import dayjs from "dayjs";
import { Autocomplete } from "@material-ui/lab";
import { CheckBox, Visibility, CheckBoxOutlineBlank } from "@material-ui/icons";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";

import MultiFileManager from "../../File/MultiFileManager/MultiFileManager";
import Other from "../ScientificResearchInsertForm/Other";
import Chapter from "../ScientificResearchInsertForm/Chapter";
import Conference from "../ScientificResearchInsertForm/Conference";
import WorkingPaper from "../ScientificResearchInsertForm/WorkingPaper";
import JournalDomestic from "../ScientificResearchInsertForm/JournalDomestic";
import ConferenceDomestic from "../ScientificResearchInsertForm/ConferenceDomestic";
import JournalInternational from "../ScientificResearchInsertForm/JournalInternational";
import EmploymentContractTable from "../../../components/EmployContractModal/EmploymentContractTable";
import EmploymentContractDetailTable from "../../../components/EmployContractModal/EmploymentContractDetailTable";

import { uploadMultiFile } from "../../../reducer/file/action";
import { statisticUnaccepted } from "../../../reducer/profile/action";
import { notification } from "../../../reducer/home/action";
import { updateScientificResearch, checkDuplicatePublication } from "../../../reducer/scientificResearch/action";
import { updateScientificResearchOther } from "../../../reducer/scientificResearchOther/action";
import {
  getEmploymentContractById,
  getAllEmploymentContractByProfileId,
} from "../../../reducer/employmentContract/action";
import DuplicateCheckModal from "../../../components/ScientificResearch/DuplicateCheckModal";
import ROUTER from "../../../constants/router";
import { getCurrentSchoolYear } from "containers/User/TimeResearch/utils";

function ScientificResearchUpdateModal(props) {
  const { employmentContractDetail, updating, setUpdating } = props;
  const [disabled, setDisabled] = useState(true);

  const [focusProfile, setFocusProfile] = useState(null);

  const [detail, setDetail] = useState(null);
  const [values, setValues] = useState(null);
  const [divideKPI, setDivideKPI] = useState(false);
  const [KPIList, setKPIList] = useState([]);
  const [profileList, setProfileList] = useState([]);
  const [studentList, setStudentList] = useState([]);
  const [helperText, setHelperText] = useState(false);
  const [studentHelperText, setStudentHelperText] = useState(false);
  const currentYear = getCurrentSchoolYear();
  const [timeResearchYear, setTimeResearchYear] = useState(currentYear);
  const [timeResearchDetailList, setTimeResearchDetailList] = useState([]);
  const [fileUrls, setFileUrls] = useState([]);
  const [newFiles, setNewFiles] = useState([]);
  const [fileManagerKey, setFileManagerKey] = useState(0);
  const [duplicateModalOpen, setDuplicateModalOpen] = useState(false);
  const [duplicateList, setDuplicateList] = useState([]);
  const [pendingSubmit, setPendingSubmit] = useState(false);

  // console.log("updating", updating);

  const isCheckedForKPI = (profile) => {
    if (divideKPI) return KPIList.find((e) => e?.profileId === profile.profileId);

    return typeof values?.profileIdForKpi === "number" && values?.profileIdForKpi === profile.profileId;
  };

  const dateFormat = (value) => (value ? dayjs(value).format("YYYY-MM-DDTHH:mm:ssZ") : null);
  // console.log("updating", updating);

  useEffect(() => {
    if (updating !== null) {
      resetValues();
      // Check if coming from duplicate selection, set to edit mode
      if (updating?._fromDuplicate) {
        setDisabled(false);
      }
    }
    if (props.listJournalDomestic?.length === 0) props.getAllJournalDomestic();
  }, [updating]);

  // useEffect(() => {
  //   if (values?.profileIdForKpi) props.getAllEmploymentContractByProfileId(values?.profileIdForKpi);
  // }, [values?.profileIdForKpi]);

  useEffect(() => {
    if (employmentContractDetail)
      setValues({
        ...values,
        profileIdForKpi: employmentContractDetail?.profile?.id,
      });
  }, [employmentContractDetail]);

  useEffect(() => {
    const contract = props?.employmentContractListById?.find(
      (e) => e?.contract?.id === updating?.contractIdForKpi,
    )?.contract;
    if (contract?.duration !== 1000) {
      if (contract?.kpi?.id === updating?.kpiIdForKpi) setDetail(contract?.kpi);
    } else {
      setDetail(contract?.listKpi?.find((e) => e.id === updating?.kpiIdForKpi));
    }
  }, [props?.employmentContractListById, updating?.contractIdForKpi]);

  useEffect(() => {
    setDetail(null);
    setValues(null);
    setProfileList([]);
    setStudentList([]);
  }, [props.filter]);

  useEffect(() => {
    if (values?.timeResearchDetailCode) {
      const selectedYear = props.timeResearchInformationList?.find(
        (info) => !!info.timeResearchDetail.find((detail) => detail.code === values?.timeResearchDetailCode),
      )?.year;

      setTimeResearchYear(selectedYear);
    }
  }, [values?.timeResearchDetailCode]);

  useEffect(() => {
    if (values && props.isUploading === false && props.fileUrl !== "") {
      const listKpiIdForKpi = JSON.stringify(
        KPIList.map((e) => ({
          ...e,
          coef: parseFloat(e?.coef),
        })),
      );

      const tempListAuthor = values?.listAuthor?.split(",").map((author) => author.trimStart());
      setValues({
        ...values,
        fileUrl: props.fileUrl,
      });
      props.updateScientificResearch(values.id, {
        ...values,
        listAuthor: tempListAuthor,
        researchProjectProfile: profileList,
        journalId: values?.journalId,
        journalDomesticId: values?.journalDomesticId,
        conferenceId:
          props.filter === "conference"
            ? values.conferenceId
            : props.filter === "conferenceDomestic"
              ? values.conferenceDomesticId
              : null,
        conferenceDomesticId: null,
        profileId: props.profile?.id,
        scientificResearchProfile: [...profileList, ...studentList],
        type: props.type,
        fileUrl: props.fileUrl,
        listKpiIdForKpi: divideKPI ? listKpiIdForKpi : null,
        acceptedDay: dateFormat(values?.acceptedDay),
        submissionDay: dateFormat(values?.submissionDay),
        dashboardYear: new Date(dateFormat(values?.acceptedDay)).getFullYear(),
      });
    }
  }, [props.isUploading]);

  const resetValues = () => {
    let tempListAuthor = "";
    updating.listAuthor?.forEach((author) => {
      if (tempListAuthor === "") tempListAuthor += author;
      else tempListAuthor += `, ${author}`;
    });

    if (updating?.listKpiIdForKpi) {
      const listKpiIdForKpi = JSON.parse(updating?.listKpiIdForKpi);
      setKPIList(listKpiIdForKpi);
      if (listKpiIdForKpi) setDivideKPI(true);
    }

    setValues({
      ...updating,
      listAuthor: tempListAuthor,
      journalId: updating?.journalId,
      journalDomesticId: updating?.journalDomesticId,
      conferenceId:
        props.filter === "conference"
          ? updating.conferenceId
          : props.filter === "conferenceDomestic"
            ? updating.conferenceDomesticId
            : null,
      conferenceDomesticId: null,
      profileId: props.profile?.id,
      scientificResearchProfile: profileList,
      type: props.type,
      acceptedDay: new Date(updating.acceptedDay),
      submissionDay: new Date(updating.submissionDay),
      dashboardYear: new Date(dateFormat(new Date(updating.acceptedDay))).getFullYear(),
    });

    // Separate students from profiles
    const profiles = [];
    const students = [];

    updating.scientificResearchProfile?.forEach((item) => {
      if (item.studentCode) {
        students.push(item);
      } else {
        profiles.push(item);
      }
    });

    setProfileList(profiles || []);
    setStudentList(students || []);

    setFileUrls(updating.fileUrl?.split("||").filter(Boolean) || []);
    setNewFiles([]);

    // props.getEmploymentContractById(updating.contractIdForKpi);

    // const contract = props.employmentContractListById?.find(
    //   (e) => e.contract.id === updating.contractIdForKpi
    // )?.contract;
    // setDetail(contract?.listKpi?.find((e) => e.id === updating.kpiIdForKpi));

    const timeResearchYearId = parseInt(updating.timeResearchDetailCode?.split("-")[0]);
    const year = props.timeResearchInformationList?.find((e) => e.id === timeResearchYearId)?.year || 2022;
    setTimeResearchYear(year);
  };

  const handleChangeForm = (name, value) => {
    if (name === "timeResearchDetailCode") {
      setValues({
        ...values,
        [name]: value === "null" ? null : value,
      });
    } else if (name === "purposeId") {
      setValues({
        ...values,
        [name]: value,
        profileIdForKpi: null,
        kpiIdForKpi: null,
        contractIdForKpi: null,
        profileIdForReward: null,
      });
    } else {
      setValues({ ...values, [name]: value });
    }
  };

  const handleChangeProfileList = (index, name, value) => {
    const temp = profileList;
    const tempElm = profileList[index];
    temp.splice(index, 1, { ...tempElm, [name]: value });
    setProfileList([...temp]);
  };

  const handleInsert = () => {
    const temp = profileList;
    temp.push({
      profileId: null,
      roleInPaper: "member",
      isInternal: true,
      externalName: "",
    });
    setProfileList([...temp]);
  };

  const handleRemove = (index) => {
    if (profileList[index].profileId === values?.profileIdForKpi) handleChangeForm("profileIdForKpi", null);

    const temp = profileList.filter((e, id) => id !== index);
    setProfileList([...temp]);
  };

  const handleChangeStudentList = (index, name, value) => {
    const temp = studentList;
    const tempElm = studentList[index];
    temp.splice(index, 1, { ...tempElm, [name]: value });
    setStudentList([...temp]);
  };

  const handleInsertStudent = () => {
    const temp = studentList;
    temp.push({
      studentName: "",
      studentCode: "",
      class: "",
      major: "",
      cohort: "",
      identity: "",
      isInternal: false,
      externalName: "",
      roleInPaper: "member",
    });
    setStudentList([...temp]);
  };

  const handleRemoveStudent = (index) => {
    const temp = studentList.filter((e, id) => id !== index);
    setStudentList([...temp]);
  };

  const handleSendFeedback = () => {
    props.history.push({
      pathname: ROUTER.NOTIFICATION,
      state: {
        sendTo: "personal",
        title: "Phản hồi về việc khai báo thông tin Công bố khoa học",
        chosenProfiles: profileList.reduce((accumulator, currentValue) => {
          accumulator.push(currentValue.profileId);
          return accumulator;
        }, []),
        data: updating,
        dataType: "scientificResearch",
      },
    });
  };

  const checkForDuplicates = async () => {
    // Check for duplicates before submitting
    const checkPayload = {
      publicationType: "scientific_researchs",
      title: values?.title || "",
      issn: values?.doi || "",
    };

    const result = await props.checkDuplicatePublication(checkPayload);

    // If API call failed, prevent submission
    if (result.error) {
      return "error"; // Return "error" to stop submission and show error message
    }

    if (result.success && result.data && result.data.length > 0) {
      // Filter out the current item being edited
      const filteredDuplicates = result.data.filter((item) => item.scientificResearch?.id !== updating?.id);

      if (filteredDuplicates.length > 0) {
        setDuplicateList(filteredDuplicates);
        setDuplicateModalOpen(true);
        return true;
      }
    }
    return false;
  };

  const handleSubmit = async (e, skipDuplicateCheck = false) => {
    const listKpiIdForKpi = JSON.stringify(
      KPIList.map((e) => ({
        ...e,
        coef: parseFloat(e?.coef),
      })),
    );

    // console.log(listKpiIdForKpi)
    if (disabled) {
      setDisabled(false);
    } else {
      // Validate student list - only if there are students added
      const hasInvalidStudents =
        studentList.length > 0 &&
        studentList.findIndex((e) => e.studentName === "" || e.identity === "" || !e.roleInPaper) >= 0;

      if (hasInvalidStudents) {
        setStudentHelperText(true);
        return;
      }

      // Validate at least one internal member
      const hasInternalMember = profileList.some((e) => e.isInternal === true);
      if (!hasInternalMember) {
        props.pushNoti({
          type: "warning",
          message: "Phải có ít nhất 1 thành viên nội bộ của trường trong công trình khoa học!",
        });
        return;
      }

      if (profileList.findIndex((e) => e.profileId === null && e.externalName === "") < 0) {
        // Check for duplicates first unless explicitly skipped or disabled
        // if (!disabled && !skipDuplicateCheck && !pendingSubmit) {
        //   const hasDuplicates = await checkForDuplicates();
        //   if (hasDuplicates === "error") {
        //     // API error occurred, don't show modal, just stop submission
        //     return;
        //   }
        //   if (hasDuplicates) {
        //     setPendingSubmit(true);
        //     return;
        //   }
        // }

        const tempListAuthor = values?.listAuthor?.split(",").map((author) => author.trimStart());

        let finalFileUrl = fileUrls.join("||");
        if (newFiles.length > 0) {
          const uploadResult = await props.uploadMultiFile(
            values.id,
            newFiles,
            props.filter !== "other" ? "scientificResearch" : "scientificResearchOther",
          );
          if (uploadResult.success && uploadResult.data) {
            const urls = Array.isArray(uploadResult.data) ? uploadResult.data : [uploadResult.data];
            finalFileUrl = [...fileUrls, ...urls].join("||");
          }
        }

        props
          .updateScientificResearch(values.id, {
            ...values,
            listAuthor: tempListAuthor,
            researchProjectProfile: profileList,
            journalId: values?.journalId,
            journalDomesticId: values?.journalDomesticId,
            conferenceId:
              props.filter === "conference"
                ? values.conferenceId
                : props.filter === "conferenceDomestic"
                  ? values.conferenceDomesticId
                  : null,
            conferenceDomesticId: null,
            profileId: props.profile?.id,
            scientificResearchProfile: [...profileList, ...studentList],
            type: props.type,
            listKpiIdForKpi: divideKPI ? listKpiIdForKpi : null,
            acceptedDay: dateFormat(values?.acceptedDay),
            submissionDay: dateFormat(values?.submissionDay),
            dashboardYear: new Date(dateFormat(values?.acceptedDay)).getFullYear(),
            fileUrl: finalFileUrl,
          })
          .then((success) => {
            if (success) {
              props.statisticUnaccepted({
                departmentId: 0,
                profileId: props.profile?.id,
              });
              if (props.role === "sudo-admin") props.statisticUnaccepted({ departmentId: 0, profileId: 0 });
            }
          });

        setValues(null);
        setDisabled(true);
        setProfileList([]);
        setStudentList([]);
        setUpdating(null);
        setHelperText(false);
        setStudentHelperText(false);
        setPendingSubmit(false);
        setFileUrls([]);
        setNewFiles([]);
        setFileManagerKey((k) => k + 1);
      } else {
        setHelperText(true);
      }
    }
  };

  const handleClose = () => {
    if (!disabled) {
      resetValues();
      setDisabled(true);
    } else {
      setUpdating(null);
      setDisabled(true);
      setDivideKPI(false);
      setKPIList([]);
      setStudentList([]);
      setDuplicateModalOpen(false);
      setDuplicateList([]);
      setPendingSubmit(false);
      setFileUrls([]);
      setNewFiles([]);
      setFileManagerKey((k) => k + 1);
    }
  };

  const handleCloseUploadModal = () => {};

  const handleSelectDuplicate = (duplicateItem) => {
    // Close duplicate modal and switch to the selected duplicate item
    setDuplicateModalOpen(false);

    // Add current user to the duplicate item's profile list if not already present
    const existingProfiles = duplicateItem.scientificResearch?.scientificResearchProfile || [];
    const currentUserExists = existingProfiles.some((p) => p.profileId === props.profile?.id);

    if (!currentUserExists) {
      const updatedProfiles = [
        ...existingProfiles,
        {
          profileId: props.profile?.id,
          roleInPaper: "member",
          isInternal: true,
          externalName: "",
        },
      ];

      // Update the item with the new profile
      const updatedItem = {
        ...duplicateItem.scientificResearch,
        scientificResearchProfile: updatedProfiles,
        journal: duplicateItem.journal,
        journalDomestic: duplicateItem.journalDomestic,
        conference: duplicateItem.conference,
        _fromDuplicate: true, // Flag to indicate this came from duplicate selection
      };
      setUpdating(updatedItem);
    } else {
      // Just switch to editing this item
      setUpdating({
        ...duplicateItem.scientificResearch,
        journal: duplicateItem.journal,
        journalDomestic: duplicateItem.journalDomestic,
        conference: duplicateItem.conference,
        _fromDuplicate: true, // Flag to indicate this came from duplicate selection
      });
    }
    setPendingSubmit(false);
  };

  const contractList = [];
  props?.employmentContractListById.forEach((e) => contractList.push(e.contract));

  const profileListFromProps = [{ id: -1, name: "" }];
  props.profileList.forEach((e) => profileListFromProps.push(e));

  // var timeResearchDetailList =
  //   props.timeResearchInformationList?.find((e) => e.year === 0)?.timeResearchDetail || [];
  // timeResearchDetailList = timeResearchDetailList.filter((e) => !e.allowedUpdateNum && e.type === "scientificResearch");

  useEffect(() => {
    if (props.timeResearchInformationList?.length > 0 && timeResearchYear) {
      let list = props.timeResearchInformationList
        ?.find((e) => e.year === 0)
        ?.timeResearchDetail.filter((e) => !e.allowedUpdateNum && e.type === "scientificResearch-" + props.filter);
      setTimeResearchDetailList(list || []);

      setValues({
        ...values,
      });
    }
  }, [props.timeResearchInformationList, timeResearchYear]);

  const yearList = [];
  props.timeResearchInformationList
    .sort((a, b) => b.year - a.year)
    .forEach((e) => {
      yearList.push(e.year);
    });

  const propsValues = {
    values: values,
    updating: updating,
    disabled: disabled,
    profileList: profileList,
    setValues: setValues,
    handleInsert: handleInsert,
    handleRemove: handleRemove,
    handleChangeForm: handleChangeForm,
    handleChangeProfileList: handleChangeProfileList,
  };

  const renderLockButton = () => {
    if (!values?.locked) return null;
    return (
      <Chip
        variant="outlined"
        label={`Đã khóa tính ${
          (values?.locked === "kpi" && "KPI") ||
          (values?.locked === "reward" && "thưởng") ||
          (values?.locked === "timeResearch" && "giờ nghiên cứu")
        }`}
        color="primary"
        style={{ fontSize: 15, float: "right", marginRight: 16 }}
      />
    );
  };

  const getTypeAsTitle = (type) => {
    switch (type) {
      case "journalInternational":
        return "trên tạp chí quốc tế";
      case "journalDomestic":
        return "trên tạp chí trong nước";
      case "conference":
        return "trên hội thảo quốc tế";
      case "conferenceDomestic":
        return "trên hội thảo trong nước";
      case "chapter":
        return "là chương sách";
      case "workingPaper":
        return "đang thực hiện";
      case "other":
        return "trên tạp chí khác";
      default:
        return "";
    }
  };

  return (
    <Dialog
      fullWidth
      keepMounted
      maxWidth={values?.profileIdForKpi !== null && values?.profileIdForKpi >= 0 ? "xl" : "lg"}
      open={updating !== null}
      onClose={() => {
        setUpdating(null);
        setDisabled(true);
      }}
      disableBackdropClick
    >
      <DialogTitle>
        {disabled
          ? `Chi tiết bài báo ${getTypeAsTitle(props.filter)}`
          : `Cập nhật bài báo ${getTypeAsTitle(props.filter)}`}
        {renderLockButton()}
      </DialogTitle>
      <DialogContent style={{ display: "flex", gap: 16, overflowX: "hidden" }}>
        <div
          style={{
            display: "flex",
            flex: "1 1 60%",
            minWidth: 0,
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Autocomplete
                fullWidth
                options={(props.departmentList || []).filter((d) => d.id !== 0)}
                disabled={disabled}
                getOptionLabel={(option) => option.name || ""}
                value={
                  (props.departmentList || []).filter((d) => d.id !== 0).find((d) => d.id === values?.departmentId) ||
                  null
                }
                onChange={(event, newValue) => handleChangeForm("departmentId", newValue?.id || null)}
                renderInput={(params) => <TextField {...params} size="small" label="Đơn vị" variant="outlined" />}
              />
            </Grid>
            {props.filter === "journalInternational" && <JournalInternational {...propsValues} />}
            {props.filter === "journalDomestic" && <JournalDomestic {...propsValues} />}
            {props.filter === "conference" && <Conference {...propsValues} />}
            {props.filter === "conferenceDomestic" && <ConferenceDomestic {...propsValues} />}
            {props.filter === "chapter" && <Chapter {...propsValues} />}
            {props.filter === "workingPaper" && <WorkingPaper {...propsValues} />}
            {props.filter === "other" && <Other {...propsValues} />}

            {props.filter === "journalInternational" && (
              <Grid item xs={12}>
                <TextField
                  select
                  fullWidth
                  size="small"
                  disabled={disabled}
                  label="Loại tạp chí quốc tế"
                  variant="outlined"
                  value={values?.internationalJournalType || ""}
                  onChange={(event) => handleChangeForm("internationalJournalType", event.target.value)}
                >
                  <MenuItem value="01">Thuộc danh mục Web of science</MenuItem>
                  <MenuItem value="02">Scopus</MenuItem>
                  <MenuItem value="03">ACI</MenuItem>
                  <MenuItem value="04">Khác</MenuItem>
                </TextField>
              </Grid>
            )}
            {props.filter === "journalDomestic" && (
              <Grid item xs={12}>
                <TextField
                  select
                  fullWidth
                  size="small"
                  disabled={disabled}
                  label="Loại tạp chí trong nước"
                  variant="outlined"
                  value={values?.domesticJournalType || ""}
                  onChange={(event) => handleChangeForm("domesticJournalType", event.target.value)}
                >
                  <MenuItem value="1">Được Hội đồng GSNN tính điểm</MenuItem>
                  <MenuItem value="2">Không được HĐGSNN tính điểm</MenuItem>
                  <MenuItem value="3">Thuộc Web of science</MenuItem>
                  <MenuItem value="4">Scopus</MenuItem>
                  <MenuItem value="5">ACI</MenuItem>
                  <MenuItem value="6">Khác</MenuItem>
                </TextField>
              </Grid>
            )}
            {props.filter === "conference" && (
              <Grid item xs={12}>
                <TextField
                  select
                  fullWidth
                  size="small"
                  disabled={disabled}
                  label="Loại hội thảo quốc tế"
                  variant="outlined"
                  value={values?.internationalConferenceType || ""}
                  onChange={(event) => handleChangeForm("internationalConferenceType", event.target.value)}
                >
                  <MenuItem value="1">Được Hội đồng GSNN tính điểm</MenuItem>
                  <MenuItem value="2">Không được Hội đồng GSNN tính điểm</MenuItem>
                  <MenuItem value="3">Thuộc danh mục WoS</MenuItem>
                  <MenuItem value="4">Scopus</MenuItem>
                  <MenuItem value="5">Khác</MenuItem>
                </TextField>
              </Grid>
            )}
            {props.filter === "conferenceDomestic" && (
              <Grid item xs={12}>
                <TextField
                  select
                  fullWidth
                  size="small"
                  disabled={disabled}
                  label="Loại hội thảo trong nước"
                  variant="outlined"
                  value={values?.domesticConferenceType || ""}
                  onChange={(event) => handleChangeForm("domesticConferenceType", event.target.value)}
                >
                  <MenuItem value="1">Được Hội đồng GSNN tính điểm</MenuItem>
                  <MenuItem value="2">Không được Hội đồng GSNN tính điểm</MenuItem>
                  <MenuItem value="3">Thuộc danh mục WoS</MenuItem>
                  <MenuItem value="4">Scopus</MenuItem>
                  <MenuItem value="5">Khác</MenuItem>
                </TextField>
              </Grid>
            )}

            {props.filter !== "workingPaper" && values?.purposeId === 5 && (
              <>
                {/* <Grid item xs={3}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    value={timeResearchYear}
                    disabled={disabled}
                    SelectProps={{ native: true }}
                    label="Năm học tính giờ nghiên cứu"
                    variant="outlined"
                    onChange={(event) => setTimeResearchYear(parseInt(event.target.value))}
                  >
                    {yearList.map((e) => (
                      <option key={`${e} - ${e + 1}`} value={parseInt(e)}>
                        {e} - {e + 1}
                      </option>
                    ))}
                  </TextField>
                </Grid> */}
                <Grid item xs={12}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    disabled={disabled}
                    label="Nhiệm vụ tính giờ nghiên cứu"
                    variant="outlined"
                    value={values?.timeResearchDetailCode || null}
                    onChange={(event) => handleChangeForm("timeResearchDetailCode", event.target.value)}
                    InputLabelProps={{
                      shrink: !(
                        values?.timeResearchDetailCode === undefined || values?.timeResearchDetailCode === null
                      ),
                    }}
                    error={!values?.timeResearchDetailCode}
                  >
                    {timeResearchDetailList.length > 0 ? (
                      timeResearchDetailList?.map((e) => (
                        <MenuItem key={e.code} value={e.code}>{`${e.description}`}</MenuItem>
                      ))
                    ) : (
                      <MenuItem value={null} disabled>
                        Chưa có dữ liệu
                      </MenuItem>
                    )}
                  </TextField>
                </Grid>
              </>
            )}

            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                label="Ghi chú"
                variant="outlined"
                value={values?.note || ""}
                disabled={disabled || values?.locked === "kpi" || values?.locked === "reward"}
                multiline
                rows={3}
                onChange={(event) => handleChangeForm("note", event.target.value)}
              />
            </Grid>

            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={values?.isOvertimeCountable || false}
                    disabled={disabled || values?.locked === "kpi" || values?.locked === "reward"}
                    onChange={(event) => handleChangeForm("isOvertimeCountable", event.target.checked)}
                    color="primary"
                  />
                }
                label="Tính giờ quy đổi riêng"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                size="small"
                type="number"
                label="Số giờ quy đổi riêng"
                variant="outlined"
                value={values?.overtimeHours ?? ""}
                disabled={
                  disabled || values?.locked === "kpi" || values?.locked === "reward" || !values?.isOvertimeCountable
                }
                onChange={(event) => handleChangeForm("overtimeHours", parseFloat(event.target.value) || 0)}
                inputProps={{
                  min: 0,
                  step: 0.1,
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="caption" style={{ color: "rgba(0, 0, 0, 0.54)", fontStyle: "italic" }}>
                Công thức quy đổi: 0,01 điểm công trình khoa học theo danh mục cho điểm của Hội đồng được tính bằng 02
                giờ.
              </Typography>
            </Grid>

            <Grid item xs={5} style={{ margin: "auto" }}>
              <Divider />{" "}
            </Grid>
            <Grid item xs={2}>
              <Typography style={{ textAlign: "center", color: "rgba(0, 0, 0, 0.30)" }}>Thành viên</Typography>
            </Grid>
            <Grid item xs={5} style={{ margin: "auto" }}>
              <Divider />{" "}
            </Grid>

            {props?.role === "sudo-admin" && values?.purposeId === 1 && (
              <Grid item xs={12}>
                <FormControlLabel
                  disabled={disabled}
                  control={<Checkbox color="primary" checked={divideKPI} onChange={() => setDivideKPI(!divideKPI)} />}
                  label="Chia KPI"
                />
              </Grid>
            )}

            <Grid item xs={12}>
              {profileList.map((e, index) => (
                <Grid key={`list-${index}`} container spacing={2}>
                  <Grid item xs={1}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={e.isInternal !== false}
                          disabled={disabled}
                          onChange={(event) => handleChangeProfileList(index, "isInternal", event.target.checked)}
                          color="primary"
                        />
                      }
                      label="Nội bộ"
                    />
                  </Grid>
                  {e.isInternal && (
                    <Grid item xs={divideKPI ? 3 : values?.purposeId !== 1 && values?.purposeId !== 99999999 ? 5 : 3}>
                      <Autocomplete
                        disableClearable
                        disabled={disabled}
                        options={props.profileList}
                        getOptionLabel={(option) => option.name}
                        value={props.profileList?.find((profile) => profile.id === e.profileId)}
                        onChange={(event, profile) => {
                          if (profileList[index]?.profileId === values?.profileIdForKpi)
                            handleChangeForm("profileIdForKpi", null);
                          handleChangeProfileList(index, "profileId", parseInt(profile?.id));
                          if (parseInt(profile?.id) >= 0) setHelperText(false);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            error={helperText && e.profileId === null}
                            size="small"
                            label="Thành viên"
                            variant="outlined"
                          />
                        )}
                      />
                      {helperText && e.profileId === null && (
                        <FormHelperText style={{ color: "red" }}>Không được để trống</FormHelperText>
                      )}
                    </Grid>
                  )}
                  {!e.isInternal && (
                    <Grid item xs={values?.purposeId !== 1 && values?.purposeId !== 99999999 ? 5 : 3}>
                      <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        label="Tên thành viên"
                        disabled={disabled}
                        value={e?.externalName || ""}
                        onChange={(event) => handleChangeProfileList(index, "externalName", event.target.value)}
                      />
                      {helperText && e.externalName === "" && (
                        <FormHelperText style={{ color: "red" }}>Không được để trống</FormHelperText>
                      )}
                    </Grid>
                  )}
                  <Grid item xs={values?.purposeId !== 1 && values?.purposeId !== 99999999 ? 5 : 3}>
                    <FormControl variant="outlined" size="small" style={{ width: "100%" }}>
                      <InputLabel id="purpose-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                        Vai trò
                      </InputLabel>
                      <Select
                        native
                        fullWidth
                        disabled={disabled}
                        labelId="purpose-label"
                        value={e?.roleInPaper || "main"}
                        onChange={(event) => handleChangeProfileList(index, "roleInPaper", event.target.value)}
                      >
                        {/* <option value={null} /> */}
                        <option value="main">Tác giả chính</option>
                        <option value="member">Đồng tác giả</option>
                        {/* <option value="mainOther">Tác giả chính tính hộ</option>
                        <option value="memberOther">Đồng tác giả tính hộ</option> */}
                      </Select>
                    </FormControl>
                  </Grid>
                  {values?.purposeId === 1 && (
                    <>
                      <Grid item xs={divideKPI ? 2 : 3}>
                        <FormControl required fullWidth disabled={disabled} error={!values?.profileIdForKpi}>
                          <Button
                            fullWidth
                            color="primary"
                            variant="outlined"
                            style={{ height: 40 }}
                            disabled={disabled || values?.locked === "kpi" || values?.locked === "reward"}
                            startIcon={isCheckedForKPI(e) ? <CheckBox /> : <CheckBoxOutlineBlank />}
                            onClick={() => {
                              setDetail(null);
                              if (!divideKPI) {
                                props.getAllEmploymentContractByProfileId(parseInt(e.profileId));
                                handleChangeForm(
                                  "profileIdForKpi",
                                  values?.profileIdForKpi !== e.profileId ? parseInt(e.profileId) : null,
                                );
                              } else {
                                setFocusProfile(e.profileId);
                                props.getAllEmploymentContractByProfileId(parseInt(e.profileId));
                                if (KPIList.find((kpi) => e.profileId === kpi?.profileId)) {
                                  setKPIList(KPIList.filter((kpi) => e.profileId !== kpi?.profileId));
                                } else {
                                  setKPIList([
                                    ...KPIList,
                                    {
                                      profileId: e.profileId,
                                      coef: 0,
                                    },
                                  ]);
                                }
                              }
                            }}
                          >
                            Tính KPI
                          </Button>
                          {!divideKPI && !values?.profileIdForKpi && !disabled && (
                            <FormHelperText>Phải chọn 1 người tính KPI</FormHelperText>
                          )}
                        </FormControl>
                      </Grid>
                      {divideKPI && (
                        <Grid item xs={2}>
                          <TextField
                            fullWidth
                            size="small"
                            label="Hệ số"
                            variant="outlined"
                            value={KPIList.find((kpi) => e.profileId === kpi?.profileId)?.coef || 0}
                            disabled={disabled || !KPIList.find((kpi) => e.profileId === kpi?.profileId)}
                            onChange={(event) =>
                              setKPIList([
                                ...KPIList.filter((kpi) => e?.profileId !== kpi?.profileId),
                                { profileId: e?.profileId, coef: event.target.value },
                              ])
                            }
                          />
                        </Grid>
                      )}
                    </>
                  )}
                  {values?.purposeId === 99999999 && (
                    <Grid item xs={3}>
                      <FormControl fullWidth disabled={disabled} error={!values?.profileIdForReward}>
                        <Button
                          fullWidth
                          color="primary"
                          variant="outlined"
                          style={{ height: 40 }}
                          disabled={disabled || values?.locked === "kpi" || values?.locked === "reward"}
                          startIcon={
                            typeof values?.profileIdForReward === "number" &&
                            values?.profileIdForReward === e.profileId ? (
                              <CheckBox />
                            ) : (
                              <CheckBoxOutlineBlank />
                            )
                          }
                          onClick={() => {
                            setDetail(null);
                            props.getAllEmploymentContractByProfileId(parseInt(e.profileId));
                            setFocusProfile(e.profileId);
                            handleChangeForm(
                              "profileIdForReward",
                              values?.profileIdForReward !== e.profileId ? parseInt(e.profileId) : null,
                            );
                          }}
                        >
                          Tính thưởng
                        </Button>
                        {!values?.profileIdForReward && !disabled && (
                          <FormHelperText>Phải chọn 1 người tính thưởng</FormHelperText>
                        )}
                      </FormControl>
                    </Grid>
                  )}
                  {divideKPI && (
                    <Grid item xs={1}>
                      <Button
                        fullWidth
                        disabled={disabled}
                        variant="outlined"
                        style={{ height: 40 }}
                        onClick={() => {
                          props.getAllEmploymentContractByProfileId(parseInt(e.profileId));
                          setFocusProfile(e.profileId);
                        }}
                      >
                        <Visibility />
                      </Button>
                    </Grid>
                  )}
                  <Grid item xs={1}>
                    <Button
                      // className={!disabled && "error-button"}
                      fullWidth
                      disabled={disabled}
                      color="secondary"
                      variant="contained"
                      style={{ height: 40 }}
                      onClick={() => handleRemove(index)}
                    >
                      Xoá
                    </Button>
                  </Grid>
                </Grid>
              ))}
            </Grid>

            <Grid item xs={12}>
              <Button fullWidth disabled={disabled} variant="outlined" onClick={handleInsert}>
                Thêm thành viên
              </Button>
            </Grid>

            <Grid item xs={5} style={{ margin: "auto" }}>
              <Divider />{" "}
            </Grid>
            <Grid item xs={2}>
              <Typography style={{ textAlign: "center", color: "rgba(0, 0, 0, 0.30)" }}>Sinh viên</Typography>
            </Grid>
            <Grid item xs={5} style={{ margin: "auto" }}>
              <Divider />{" "}
            </Grid>

            <Grid item xs={12}>
              {studentList.map((e, index) => (
                <Grid key={`student-${index}`} container spacing={2} style={{ marginBottom: 8 }}>
                  <Grid item xs={5}>
                    <TextField
                      required
                      fullWidth
                      size="small"
                      variant="outlined"
                      label="Tên sinh viên"
                      disabled={disabled}
                      value={e?.studentName || ""}
                      error={studentHelperText && e.studentName === ""}
                      onChange={(event) => handleChangeStudentList(index, "studentName", event.target.value)}
                    />
                    {studentHelperText && e.studentName === "" && (
                      <FormHelperText style={{ color: "red" }}>Không được để trống</FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      required
                      fullWidth
                      size="small"
                      variant="outlined"
                      label="Mã sinh viên"
                      disabled={disabled}
                      value={e?.studentCode || ""}
                      error={studentHelperText && e.studentCode === ""}
                      onChange={(event) => handleChangeStudentList(index, "studentCode", event.target.value)}
                    />
                    {studentHelperText && e.studentCode === "" && (
                      <FormHelperText style={{ color: "red" }}>Không được để trống</FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={3}>
                    <FormControl
                      required
                      fullWidth
                      variant="outlined"
                      size="small"
                      error={studentHelperText && !e?.roleInPaper}
                    >
                      <InputLabel
                        id={`student-roleInPaper-label-${index}`}
                        style={{ padding: "0 8px", backgroundColor: "white" }}
                      >
                        Vai trò
                      </InputLabel>
                      <Select
                        native
                        fullWidth
                        disabled={disabled}
                        labelId={`student-roleInPaper-label-${index}`}
                        value={e?.roleInPaper || "member"}
                        onChange={(event) => handleChangeStudentList(index, "roleInPaper", event.target.value)}
                      >
                        <option value="main">Tác giả chính</option>
                        <option value="member">Đồng tác giả</option>
                      </Select>
                    </FormControl>
                    {studentHelperText && !e?.roleInPaper && (
                      <FormHelperText style={{ color: "red" }}>Không được để trống</FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={1}>
                    <Button
                      fullWidth
                      disabled={disabled}
                      color="secondary"
                      variant="contained"
                      style={{ height: 40 }}
                      onClick={() => handleRemoveStudent(index)}
                    >
                      Xóa
                    </Button>
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      size="small"
                      variant="outlined"
                      label="Lớp"
                      disabled={disabled}
                      value={e?.class || ""}
                      onChange={(event) => handleChangeStudentList(index, "class", event.target.value)}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      size="small"
                      variant="outlined"
                      label="Ngành học"
                      disabled={disabled}
                      value={e?.major || ""}
                      onChange={(event) => handleChangeStudentList(index, "major", event.target.value)}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      size="small"
                      variant="outlined"
                      label="Khóa"
                      disabled={disabled}
                      value={e?.cohort || ""}
                      onChange={(event) => handleChangeStudentList(index, "cohort", event.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      size="small"
                      variant="outlined"
                      label="Số CMND/CCCD"
                      disabled={disabled}
                      value={e?.identity || ""}
                      onChange={(event) => handleChangeStudentList(index, "identity", event.target.value)}
                    />
                  </Grid>
                </Grid>
              ))}
            </Grid>

            <Grid item xs={12}>
              <Button fullWidth disabled={disabled} variant="outlined" onClick={handleInsertStudent}>
                Thêm sinh viên
              </Button>
            </Grid>
          </Grid>
        </div>
        <div
          style={{
            flex: "0 0 380px",
            display: "flex",
            flexDirection: "column",
            gap: 12,
            overflowY: "auto",
          }}
        >
          <div>
            <Typography
              variant="subtitle2"
              style={{
                marginBottom: 4,
                color:
                  !disabled &&
                  props.filter !== "workingPaper" &&
                  !values?.doi &&
                  fileUrls.length === 0 &&
                  newFiles.length === 0
                    ? "#f44336"
                    : "rgba(0,0,0,0.54)",
              }}
            >
              File minh chứng
              {!disabled && props.filter !== "workingPaper" && !values?.doi && (
                <span style={{ color: "#f44336", marginLeft: 2 }}>*</span>
              )}
            </Typography>
            {!disabled &&
              props.filter !== "workingPaper" &&
              !values?.doi &&
              fileUrls.length === 0 &&
              newFiles.length === 0 && (
                <Typography variant="caption" style={{ color: "#f44336", display: "block", marginBottom: 6 }}>
                  Bắt buộc khi không có DOI
                </Typography>
              )}
            <MultiFileManager
              key={fileManagerKey}
              fileUrls={fileUrls}
              setFileUrls={setFileUrls}
              newFiles={newFiles}
              setNewFiles={setNewFiles}
              disabled={disabled}
            />
          </div>
          {values?.profileIdForKpi !== null && values?.profileIdForKpi >= 0 && (
            <>
              <EmploymentContractTable
                values={values}
                contract={detail}
                KPIList={KPIList}
                divideKPI={divideKPI}
                focusProfile={focusProfile}
                contractList={contractList}
                kpiIdForKpi={values?.kpiIdForKpi}
                disabled={disabled || values?.locked}
                contractIdForKpi={values?.contractIdForKpi}
                setDetail={setDetail}
                setValues={setValues}
                setKPIList={setKPIList}
                handleChangeForm={handleChangeForm}
              />
              {/* <EmploymentContractTable
            values={values}
            contract={detail}
            KPIList={KPIList}
            divideKPI={divideKPI}
            contractList={contractList}
            kpiIdForKpi={values?.kpiIdForKpi}
            disabled={disabled || values?.locked}
            contractIdForKpi={values?.contractIdForKpi}
            setDetail={setDetail}
            setValues={setValues}
            setKPIList={setKPIList}
            handleChangeForm={handleChangeForm}
          /> */}
              <EmploymentContractDetailTable disabled={disabled || values?.locked} kpi={detail} />
            </>
          )}
        </div>
      </DialogContent>
      <DialogActions style={{ padding: "0 24px 8px 24px" }}>
        <Grid container justifyContent={"space-between"}>
          <div></div>
          <div>
            {props.adminTab && (
              <Button variant="outlined" onClick={handleSendFeedback}>
                Gửi feedback
              </Button>
            )}
            <Button variant="outlined" color="secondary" onClick={handleClose} style={{ margin: "0 4px" }}>
              Huỷ
            </Button>
            {!window.location.href.includes("management") ||
            (window.location.href.includes("management") && props.role === "sudo-admin") ? (
              <Tooltip
                disableHoverListener={props.role === "sudo-admin"}
                title="Liên hệ phòng KHCN để đề xuất chỉnh sửa CTKH"
              >
                <span>
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={
                      (!disabled &&
                        ((values?.purposeId === 1 && !(values?.profileIdForKpi && values?.contractIdForKpi)) ||
                          (values?.purposeId === 99999999 && !values?.profileIdForReward) ||
                          !(values?.numberMainAuthor > 0) ||
                          // !(values?.submissionMonth > 0) ||
                          // !(values?.acceptedMonth > 0) ||
                          !(values?.numOfMember > 0) ||
                          (values?.purposeId === 5 && !values?.timeResearchDetailCode))) ||
                      values?.locked ||
                      (values?.accepted && props.role !== "sudo-admin")
                    }
                    onClick={handleSubmit}
                  >
                    {disabled ? "Chỉnh sửa" : "Xác nhận"}
                  </Button>
                </span>
              </Tooltip>
            ) : (
              <></>
            )}
          </div>
        </Grid>
      </DialogActions>
      <DuplicateCheckModal
        open={duplicateModalOpen}
        duplicates={duplicateList}
        onClose={() => {
          setDuplicateModalOpen(false);
          setPendingSubmit(false);
        }}
        onSelectDuplicate={handleSelectDuplicate}
      />
    </Dialog>
  );
}

const mapStateToProps = (state) => ({
  role: select(state, "userReducer", "role"),
  history: select(state, "homeReducer", "history"),
  profile: select(state, "profileReducer", "detail"),
  profileList: select(state, "profileReducer", "list"),
  profileDepartments: select(state, "profileReducer", "departments"),
  departmentList: select(state, "departmentReducer", "departments"),
  detailYear: select(state, "timeResearchInformationReducer", "detail"),
  employmentContractDetail: select(state, "employmentContractReducer", "detail"),
  employmentContractListById: select(state, "employmentContractReducer", "listById"),
  timeResearchInformationList: select(state, "timeResearchInformationReducer", "list"),
  isFetchingTimeResearchInformation: select(state, "timeResearchInformationReducer", "isFetching"),
});

const mapDispatchToProps = (dispatch) => ({
  uploadMultiFile: (id, files, type) => dispatch(uploadMultiFile(id, files, type)),
  statisticUnaccepted: (payload) => dispatch(statisticUnaccepted(payload)),
  getEmploymentContractById: (id) => dispatch(getEmploymentContractById(id)),
  updateScientificResearch: (id, payload) => dispatch(updateScientificResearch(id, payload)),
  getAllEmploymentContractByProfileId: (id) => dispatch(getAllEmploymentContractByProfileId(id)),
  updateScientificResearchOther: (id, payload) => dispatch(updateScientificResearchOther(id, payload)),
  checkDuplicatePublication: (payload) => dispatch(checkDuplicatePublication(payload)),
  pushNoti: (payload) => dispatch(notification(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(ScientificResearchUpdateModal));

